import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { SharedService } from './shared.service';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class NetworkService {
  accessToken: any;
  constructor (
    private router: Router,
    private sharedService: SharedService,
  ) { }

  httpRequest (
    url: string,
    body: any = null,
    method: string = 'GET',
    authenticated: boolean = true,
    headers = {},
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      fetch(environment.baseUrl + url, {
        method,
        headers: JSON.parse(JSON.stringify({
          'Content-Type': 'application/json',
          Credentials: 'include',
          Authorization: authenticated
            ? `Bearer ${ localStorage.getItem('token') }`
            : null,
          ...headers,
        })),
        body: body
          ? JSON.stringify(body)
          : null,
      })
        .then((response: any) => response.json())
        .then((response: any) => {
          if (response.code === 401) {
            reject(response.data);
            this.redirectToLogin();
          } else if (response.code === 403) {
            if (response.message.toLowerCase().match(/inactive/gi)) {
              localStorage.removeItem('token');
              localStorage.removeItem('impersonate');

              reject(response.data);
              this.router.navigate([ '/confirm-email' ], { queryParams: { id: response.data._id } })
                .then();
            } else if (response.message.toLowerCase()
              .match(/you don't have permission to access this resource/gi)) {
              console.log('You don\'t have permission to access this resource. Page url', window.location.href);
              reject(response.data);
            } else if (response.message.toLowerCase()
              .match(/You are logging in to the incorrect agency account, Kindly change the login URL and login again./gi)) {
              reject(response.message);
            } else {
              reject(new Error(response?.message || 'Something went wrong'));
            }
          } else {
            if (!response.success) {
              return reject(response.data || response.message);
            }
            return resolve(response.data);
          }
        })
        .catch((error) => {
          this.sharedService.showToast('error', '', error.message);
        });
    });
  }

  redirectToLogin (): void {
    localStorage.removeItem('token');
    localStorage.removeItem('impersonate');
    window.location.href = '/authentication';
  }

}
